import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";

const SelectInput = (props) => {
	const hasValue = (typeof props.value !== "undefined" && props.value !== null);
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const hasLabel = !!props.label;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const defaultItem = props.defaultItem ? props.defaultItem : "Kies een optie";
	const defaultItemVisible = props.defaultItemVisible != null ? props.defaultItemVisible : true;
	const defaultValueIndex = props.items.map(item => item.label).indexOf(defaultItem);
	const defaultValue = defaultValueIndex > -1 ? props.items[defaultValueIndex].value : "";

	const value = hasValue ? props.value : defaultValue;
	const sizeClassName = props.size ? "o-col-" + props.size : (props.small ? "" : props.applySizeClass ? "o-col-12" : "");
	const label = hasLabel ? props.label + (props.optional ? " (Optioneel)" : "") : null;
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const id = generateGuid();

	const small = props.small;
	const style = props.small ? { margin: "4px", padding: "2px 30px 2px 2px", minHeight: "2em", color: "black", fontWeight: "normal", width: "auto" } : (props.margin ? { marginBottom: props.margin, marginTop: props.margin } : null);

	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": true
	});

	const containerClassName = props.small ? null : classnames({
		"c-input": true,
		"c-input--dropdown": true,
		"has-value": true,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled
	});
	const defaultOption = defaultValueIndex > -1 ? "" : <option value={defaultValue}>{defaultItem}</option>;

	const select = (<select
		id={id}
		value={value}
		onChange={props.onChange}
		disabled={props.disabled}
		name={props.name}
		className={inputClassName} >
		{defaultItemVisible ? defaultOption : null}
		{
			props.items.map((item) => {
				return (
					<option key={item.value} value={item.value}>
						{item.label}
					</option>);
			})
		}
	</select>);

	return (small ? select :
		<div className={sizeClassName}>
			<div className={containerClassName}
				style={style}>
				{select}
				{hasLabel ? <label className={labelClassName} htmlFor={id}>{label}</label> : null}
				{info}
			</div>
			{validation}
		</div>);
};

SelectInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
		PropTypes.bool
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	defaultItem: PropTypes.string,
	defaultItemVisible: PropTypes.bool,
	items: PropTypes.array.isRequired,
	small: PropTypes.bool,
	margin: PropTypes.bool,
	applySizeClass: PropTypes.bool
};

export default SelectInput;
